import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const SellStickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-50 md:hidden p-3 bg-background/90 backdrop-blur-xl border-t border-border/50 shadow-[0_-8px_30px_-12px_rgba(0,0,0,0.2)]"
        >
          <a 
            href="#pricing"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
          >
            <Button className="w-full py-5 bg-gradient-to-r from-primary to-accent hover:opacity-90 shadow-lg shadow-primary/25 font-semibold text-sm sm:text-base">
              🚀 Mon portfolio dès 79€
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SellStickyMobileCTA;
